import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BiData } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { URLS, Url } from '@wix/da-url';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import { getEnv } from '@wix/da-react-app/pkg/client/Environment/redux/selectors';
import { showSubmitModal } from '../../Modals/redux/actionCreators';
import { ModalType } from '../../Modals/redux/types';
import { useRestrictToLoggedIn } from '../../utils/hooks/useRestrictToLoggedIn';
import { useVerification } from '../../VerificationPopup/withVerification';
const modalTypesForLinking = {
    [ModalType.STATUS_UPDATE]: 'status',
    [ModalType.JOURNAL]: 'journal',
    [ModalType.LITERATURE]: 'literature',
    [ModalType.POLL_EDIT]: 'poll',
    [ModalType.TIER_EDIT]: 'tier'
};
function getBiData(type, href) {
    if (href) {
        return BiData({
            evid: 702,
            menu_item: type,
            menu_name: 'submit',
            link_url: href
        });
    }
    return BiData({
        evid: 702,
        menu_item: type,
        menu_name: 'submit'
    });
}
/** handles stuff like verification, loggedout, legacy header for submit menu items */ export function useSubmitMenuItem({ modalType: modalTypeProp, link, verificationAction, type, modalOptions, isLegacyHeader }) {
    const { isVerificationNeeded, pushVerificationPopup } = useVerification();
    const { isLoggedIn, sendUserToJoinPage } = useRestrictToLoggedIn();
    const dispatch = useDispatch();
    const isDeviationSubmit = [
        'submitbutton',
        'deviation'
    ].includes(type);
    const { requestUrl } = useSelector(getEnv);
    const parsedUrl = new URL(requestUrl || URLS.ROOT); // defaults to URLS.ROOT when in storybook
    // If deviationids/stashids params are present we say it's not studio because we're not in the root folder
    // and we want to link to root folder for upload.
    const inStudio = parsedUrl.pathname === '/studio' && !parsedUrl.searchParams.get('deviationids') && !parsedUrl.searchParams.get('stashids');
    // Open submit via redirect to studio, unless we are in studio already
    const modalType = modalTypeProp || (isDeviationSubmit && inStudio ? ModalType.DEVIATION_SUBMIT : undefined);
    const menuItem = useMemo(()=>{
        const linkTo = isDeviationSubmit ? Url.studio({
            openSubmitForm: true
        }) : modalType ? `${Url.browseHomeLink()}?submit_modal=${modalTypesForLinking[modalType]}` : link;
        // if user is not logged in, send them to fix that
        if (!isLoggedIn) {
            return {
                onClick: ()=>yieldToMain(()=>sendUserToJoinPage(ReferralType.SUBMIT))
            };
        }
        // if not verified, show appropriate modal
        // except on legacy header which cannot do modals, but thats okay because
        // it will get redirected to some page that handles it anyway
        if (isVerificationNeeded && !isLegacyHeader) {
            return {
                onClick: ()=>yieldToMain(()=>pushVerificationPopup(verificationAction))
            };
        }
        // modal-type submits
        if (modalType) {
            // legacy does not do modals, so redirect to home and show it there
            return isLegacyHeader ? {
                href: linkTo,
                biData: getBiData(type, linkTo)
            } : {
                onClick: ()=>yieldToMain(()=>{
                        dispatch(showSubmitModal(modalType, modalOptions));
                    }),
                biData: getBiData(type)
            };
        }
        // everything else goes brrr
        return {
            href: linkTo,
            biData: getBiData(type, linkTo)
        };
    }, [
        dispatch,
        isLegacyHeader,
        isLoggedIn,
        isVerificationNeeded,
        link,
        modalOptions,
        modalType,
        pushVerificationPopup,
        sendUserToJoinPage,
        type,
        verificationAction,
        isDeviationSubmit
    ]);
    return menuItem;
}

//# sourceMappingURL=useSubmitMenuItem.js.map